"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BactoviralResearch = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const ResourceType_1 = require("../../ResourceType");
const SelectCard_1 = require("../../inputs/SelectCard");
class BactoviralResearch extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.BACTOVIRAL_RESEARCH,
            tags: [Tags_1.Tags.MICROBE, Tags_1.Tags.SCIENCE],
            cost: 10,
            metadata: {
                cardNumber: 'X35',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.cards(1).br.br;
                    b.microbes(1).asterix().slash().science().played;
                }),
                description: 'Draw 1 card. Choose 1 of your played cards and add 1 microbe to it for each science tag you have, including this.',
            },
        });
    }
    play(player) {
        player.drawCard();
        const scienceTags = player.getTagCount(Tags_1.Tags.SCIENCE) + 1;
        const microbeCards = player.getResourceCards(ResourceType_1.ResourceType.MICROBE);
        if (microbeCards.length === 0) {
            return undefined;
        }
        else if (microbeCards.length === 1) {
            player.addResourceTo(microbeCards[0], { qty: scienceTags, log: true });
        }
        else if (microbeCards.length > 1) {
            return new SelectCard_1.SelectCard('Select card to add ' + scienceTags + ' microbe(s)', 'Add microbe(s)', microbeCards, (foundCards) => {
                player.addResourceTo(foundCards[0], { qty: scienceTags, log: true });
                return undefined;
            });
        }
        return undefined;
    }
}
exports.BactoviralResearch = BactoviralResearch;
//# sourceMappingURL=BactoviralResearch.js.map